const React = require("react");

function NoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_2",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M19.789,8.857v10.884c0,1.245-1.014,2.259-2.259,2.259H4.297 c-1.245,0-2.259-1.014-2.259-2.259V6.508c0-1.245,1.014-2.259,2.259-2.259h10.884"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    strokeMiterlimit: 10,
    points: "10.004,13.631 18.586,5.086 18.927,5.42 10.403,13.933 9.761,14.223  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M20.524,3.117l0.251-0.251C20.833,2.809,20.9,2.8,20.936,2.8 c0.039,0,0.098,0.01,0.151,0.058c0.059,0.053,0.073,0.117,0.074,0.16c0.001,0.043-0.008,0.107-0.063,0.165l-0.246,0.256 L20.524,3.117z"
  }))));
}

module.exports = NoteIcon;